export default "__VITE_ASSET__EXhl407D__"